import { gql, useQuery } from '@apollo/client';

export const GET_CURRENT_PAYMENT_HISTORY = gql`
  query ($queryOptions: PaymentHistoryInput) {
    getCurrentPaymentHistory(queryOptions: $queryOptions) {
      collection {
        _id
        amount
        createdAt
        currency
        description
        status
        stripeSubscriptionId
      }
      hasMore
    }
  }
`;

export const useGetCurrentPaymentHistory = ({
  startingAfter,
  endingBefore,
}: {
  startingAfter?: string;
  endingBefore?: string;
}) => {
  const pageSize = 12;
  const { data, loading } = useQuery(GET_CURRENT_PAYMENT_HISTORY, {
    variables: {
      queryOptions: {
        limit: pageSize,
        startingAfter,
        endingBefore,
      },
    },
    fetchPolicy: 'network-only',
  });

  const paymentHistory = data ? data.getCurrentPaymentHistory.collection : [];
  const hasMore = data && data.getCurrentPaymentHistory.hasMore;

  return {
    paymentHistory,
    loading,
    hasMore,
  };
};
